import Stack from '@mui/material/Stack';
import styled from 'styled-components';
import { route } from '../../route/Index';
import { useAppSelector } from '../../store/hook';
import { selectProject } from '../../store/project/projectSlice';
import { selectUser } from '../../store/user/userSlice';
import Backoffice from './Backoffice';
import Export from './Export';
import Help from './Help';
import Language from './Language';
import New from './New';
import Open from './Open';
import Profile from './Profile';
import Save from './Save';
import { ERole } from '../../shared/enum';

interface IActionProps {}

const ActionContainer = styled(Stack)`
    background-color: #f5f5f5;
    height: 2.5rem;
`;

const Action = (props: IActionProps) => {
    const project = useAppSelector(selectProject);
    const user = useAppSelector(selectUser);

    let projectId = project.data?.id;

    let pathname = window.location.pathname;
    if (pathname.endsWith('/')) {
        pathname = pathname.slice(0, -1);
    }

    return (
        <ActionContainer direction='row' justifyContent='space-between' alignItems='center' overflow='none'>
            <Stack direction='row' spacing={{ xs: 0, sm: 0, md: 1 }}>
                <New />
                <Open />
                {projectId && route.design.replace(':projectId', projectId.toString()) && (
                    <>
                        <Save />
                        <Export />
                    </>
                )}
                <Language />
                <Help />
            </Stack>
            <Stack direction={'row'} spacing={{ xs: 0, sm: 1 }}>
                <Profile />
                {user.data!.role == ERole.Admin && <Backoffice />}
            </Stack>
        </ActionContainer>
    );
};

export default Action;
